<template>
  <div class="content">
    <div class="img-introduce">
      <el-carousel height="466" :interval="6000" arrow="never">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index" height="466" arrow="never">
          <img :src="item.url||appImg" alt="" width="1190" height="466">
        </el-carousel-item>
      </el-carousel>
    </div>
    <h2>软件下载</h2>
     <!-- <el-upload
        ref="upLoadFile"
        class="upload-demo"
        action="https://jsonplaceholder.typicode.com/posts/"
        :on-preview="handlePreview"
        :before-upload="beforeUpload"
        multiple
        :http-request="getOssKey"
        :auto-upload="true"
        :on-exceed="handleExceed"
        :file-list="fileListC">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">单个文件大小不能超过100mb</div>
      </el-upload> -->
    <div class="box-shadow soft-table">
      <div class="table-row th">
        <div class="name">软件名</div>
        <div class="version">版本</div>
        <div class="system">操作系统</div>
        <div class="size">软件包大小</div>
        <div class="detail">详情</div>
        <div class="operation">操作</div>
      </div>
      <div class="table-row" v-for="(item, index) in softList" :key="index">
        <div class="name">{{item.name}}</div>
        <div class="version">{{item.version}}</div>
        <div class="system">{{item.system}}</div>
        <div class="size">{{item.size}}</div>
        <div class="detail detail-content" :class="{ disable: !item.otherUrl }" @click="detailHandle(item)">查看</div>
        <div class="operation detail-content" @click="downLoad(item.ossUrl, item.name)">
          <i class="el-icon-download" style="font-weight: 900;"></i>下载
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { openOther } from '@/utils'
// import { swClickCount } from '@/utils/eventTracking'
import { getAccessToken } from '@/utils/userInfo'
// const OSS = require('ali-oss')
export default {
  data () {
    return {
      appImg: require('@/assets/img/software4.jpg'),
      fileListC: [],
      softList: [
        {
          name: '屏幕管理软件',
          version: 'V2.0',
          system: 'Windows兼容版本',
          size: '7.23MB',
          url: require('@/assets/img/software1.jpg'),
          ossId: 20788, // 18004,
          ossUrl: 'https://plantmate-privacy-prod.oss-cn-hangzhou.aliyuncs.com/software/VxMonitorLock%20V1.00.00.01-200311-C.exe.zip'
          // otherUrl: 'planContent?title=%E5%AE%89%E5%85%A8%E7%AE%A1%E7%90%86&title1=&key=%E5%B1%8F%E5%B9%95%E7%AE%A1%E7%90%86%E8%BD%AF%E4%BB%B6&id=292'
        },
        {
          name: '实时数据库软件',
          version: 'V5.3',
          system: 'Windows兼容版本',
          size: '190MB',
          url: require('@/assets/img/software2.jpg'),
          ossId: 20786, // 18005,
          ossUrl: 'https://plantmate-privacy-prod.oss-cn-hangzhou.aliyuncs.com/software/ESPiSYS.7z'
          // otherUrl: 'detail?idxArr=3,12,0&id=362901623095939072&key=362901623095939072%7C%E5%93%81%E7%89%8C%3A%E4%B8%AD%E6%8E%A7%C2%B7SUPCON%24%E5%9E%8B%E5%8F%B7%3AESP-iCore%7C314135607267823616%7C%E4%B8%AD%E6%8E%A7%E5%AE%9E%E6%97%B6%E6%95%B0%E6%8D%AE%E5%B9%B3%E5%8F%B0'
        },
        {
          name: '高级报警管理软件',
          version: 'V2.0',
          system: 'Windows兼容版本',
          size: '407MB',
          url: require('@/assets/img/software3.jpg'),
          ossId: 20789, // 18002,
          ossUrl: 'https://plantmate-privacy-prod.oss-cn-hangzhou.aliyuncs.com/software/VxAAS_20200311-2.0.2.2974.7z'
          // otherUrl: 'planContent?title=%E5%AE%89%E5%85%A8%E7%AE%A1%E7%90%86&title1=%E7%94%9F%E4%BA%A7%E6%8A%A4%E8%88%AA&key=%E5%85%88%E8%BF%9B%E6%8A%A5%E8%AD%A6%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F&id=198'
        },
        {
          name: 'PID性能评估软件',
          version: 'V3.0',
          system: 'Windows兼容版本',
          size: '497MB',
          url: require('@/assets/img/software4.jpg'),
          ossId: 20787, // 18003,
          ossUrl: 'https://plantmate-privacy-prod.oss-cn-hangzhou.aliyuncs.com/software/PID-Suite%20V3.0.7z',
          // otherUrl: 'https://www.plantmate.com/detail?idxArr=3,8,0&id=362893471839408128&key=362893471839408128%7C%E5%93%81%E7%89%8C%3A%E4%B8%AD%E6%8E%A7%C2%B7SUPCON%24%E5%9E%8B%E5%8F%B7%3APID-CPA%24%E7%B3%BB%E5%88%97%3APID%7C314135645918334976%7CPID%E6%80%A7%E8%83%BD%E8%AF%84%E4%BC%B0%E8%BD%AF%E4%BB%B6'
          otherUrl: 'goodDetail?spuId=2314135645918334976&skuId='
        },
        {
          name: '中控InPlant SCADA',
          version: 'V5.5.1',
          system: 'Windows兼容版本',
          size: '646MB',
          // url: require('@/assets/img/software4.jpg'),
          ossId: 20787, // 18003,
          ossUrl: 'https://plantmate-privacy-prod.oss-cn-hangzhou.aliyuncs.com/software/InPlant%20SCADA%20V5.5%20SP01%E5%AE%89%E8%A3%85%E5%8C%85.zip'
          // otherUrl: 'https://www.plantmate.com/detail?idxArr=3,8,0&id=362893471839408128&key=362893471839408128%7C%E5%93%81%E7%89%8C%3A%E4%B8%AD%E6%8E%A7%C2%B7SUPCON%24%E5%9E%8B%E5%8F%B7%3APID-CPA%24%E7%B3%BB%E5%88%97%3APID%7C314135645918334976%7CPID%E6%80%A7%E8%83%BD%E8%AF%84%E4%BC%B0%E8%BD%AF%E4%BB%B6'
          // otherUrl: ''
        }
      ],
      index: -1,
      bucketName: '',
      accessKeyId: '',
      accessKeySecret: '',
      stsToken: '',
      subLoading: false
    }
  },
  computed: {
    bannerList () {
      return this.softList.filter(item => item.url)
    }
  },
  created () {
    // this.$http.post(`${window.SITE_CONFIG['forumURL']}/alioss/sysossali/deleteAliOss/18002`)
    // this.$http.post(`${window.SITE_CONFIG['forumURL']}/alioss/sysossali/deleteAliOss/18003`)
    // this.$http.post(`${window.SITE_CONFIG['forumURL']}/alioss/sysossali/deleteAliOss/18004`)
    // this.$http.post(`${window.SITE_CONFIG['forumURL']}/alioss/sysossali/deleteAliOss/18005`)
  },
  methods: {
    changeImg (index) {
      this.index = index
    },
    downLoad (url, name) {
      if (getAccessToken()) {
        this.$http.post(`/help/user/sys/report/swdownloadrecord/save`, {
          swName: name
        })
        openOther(url, true)
      } else {
        this.$confirm(
          `请登录`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            this.$router.push({ name: 'login' })
          })
      }
    },
    detailHandle (item) {
      if (item.otherUrl) {
        // swClickCount(item.name)
        // openOther(item.otherUrl, true)
        openOther(item.otherUrl)
      }
    }
    // handlePreview(file) {
    //   // console.log(file);
    // },
    // handleExceed(files, fileList) {
    //   this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    // },
    // beforeUpload (file) {
    //   if (this.subLoading) {
    //     return false
    //   }
    //   // let newName = file.name.slice(0, file.name.lastIndexOf('.'))
    //   // let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
    //   // if (regx.test(newName)) {
    //   // } else {
    //   //   this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
    //   //   return false
    //   // }
    //   // const isLt2M = file.size / 1024 / 1024 < 100;
    //   // if (!isLt2M) {
    //   //   this.$message.error('上传的附件不得大于100MB');
    //   // }
    //   // return isLt2M
    //   return true
    // },
    // // 获取OSS参数
    // getOssKey (file) {
    //   this.$http.get(`${window.SITE_CONFIG['forumURL']}/alioss/sysossali/getAliOssToken`)
    //     .then(item => {
    //       if (item.result.code === 0) {
    //         console.log(item.result)
    //         this.bucketName = item.result.bucketName
    //         this.accessKeyId = item.result.accessKeyId
    //         this.accessKeySecret = item.result.accessKeySecret
    //         this.stsToken = item.result.securityToken
    //         // this.getAliTime = new Date(item.result.expiration)
    //         this.uploadOss(file)
    //         // this.putBlob()
    //       } else {
    //         this.$message.error(item.result.msg)
    //       }
    //     })
    //     .catch(error => {
    //       this.subLoading = false
    //     })
    // },
    // // 上传
    // async uploadOss (file) {
    //   try {
    //     // if (this.subLoading) {
    //     //   return false
    //     // }
    //     let timeStamp = new Date().getTime()
    //     let _this1 = this
    //     let oldObj = `softWare/${timeStamp}/${file.file.name}`
    //     let objectName = oldObj.replace(/\+/g, "")
    //     console.log(objectName, 'objectName')
    //     this.subLoading = true
    //     // if (this.getAliTime.getTime() < new Date().getTime()) {
    //     //   await this.getOssKey()
    //     // }
    //     await new OSS({
    //       region: `oss-cn-hangzhou`,
    //       accessKeyId: `${this.accessKeyId}`,
    //       accessKeySecret: `${this.accessKeySecret}`,
    //       bucket: `${this.bucketName}`,
    //       stsToken: `${this.stsToken}`
    //     }).multipartUpload(`${objectName}`, file.file, {
    //       progress: async function (p, checkpoint) {
    //       // 断点记录点。 浏览器重启后无法直接继续上传，需用户手动触发进行设置。
    //         // console.log(p, checkpoint)
    //         _this1.progress = parseInt(p * 100)
    //         _this1.p = p
    //         // file.percentage(p)
    //         file.onProgress({percent:parseInt(p * 100)})
    //         // e.percent
    //         // this.tempCheckpoint = checkpoint
    //         if (p === 1) {
    //           console.log(p, checkpoint, objectName)
    //           _this1.getVideoOssId(objectName, file, checkpoint)
    //         }
    //       }
    //     })
    //   } catch (e) {
    //     this.subLoading = false
    //     console.log(e)
    //     file.onError(file)
    //     this.$message.warning('上传失败，请重新上传')
    //   }
    // },
    // getVideoOssId (objectName, file, checkpoint) {
    //   this.$http.post(`${window.SITE_CONFIG['forumURL']}/alioss/sysossali/aliOssUploadDemandAttachment`, {
    //     objectName: objectName,
    //     fileName: file.file.name,
    //     fileSize: file.file.size.toString()
    //   })
    //   .then(data => {
    //     if (data.result && data.result.code === 0) {
    //       console.log(data, 'data')
    //       // this.fileListS.push({
    //       //   uid: file.file.uid,
    //       //   ossId: data.result.aliOssId,
    //       //   ossName: objectName
    //       //   // uploadId: checkpoint.uploadId
    //       // })
    //     } else {
    //       file.onError(file)
    //     }
    //     this.subLoading = false
    //   })
    //   .catch(error => {
    //     file.onError(file)
    //     this.subLoading = false
    //   })
    // }
  }
}
</script>
<style scoped>
.content{
  width: 1190px;
  margin: 0px auto;
}
.img-introduce{
  width: 100%;
  height: 466px;
}
h2{
  margin: 10px 0;
}
.soft-table{
  background: none;
}
.table-row{
  width: 100%;
  display: flex;
  justify-content: space-between;
  line-height: 40px;
  padding-left: 20px;
}
.th{
  color: #bbb;
}
.table-row:nth-child(odd){
  background-color: #fff;
}
.name{
  width: 30%;
}
.version{
  width: 100px;
}
.system{
  width: 150px;
}
.size{
  width: 100px;
}
.detail{
  width: 100px;
}
.detail.disable {
  color: #bbb;
}
.detail-content{
  color: #1D65A8;
  cursor: pointer;
}
.operation{
  width: 100px;
}
.download{}
.el-carousel__arrow{
  display: none;
}
.el-carousel{
  height: 466px;
}
.el-carousel__container{
  height: 466px;
}
.el-carousel__item{
  height: 466px;
}
.el-carousel__item img{
  height: 466x;
  width: 100%;
  /* width: 1190px; */
  display: block;
}
</style>
